var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transition',{attrs:{"name":"slip_preloader"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.PRELOADER_STATE),expression:"PRELOADER_STATE"}],staticClass:"preloader"},[_c('img',{attrs:{"src":"https://bpcard.ru/images/logo_png_160px.png","alt":""}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }